import { gql } from "lib/apolloClient";
import { userFragment } from "./Fragments";

export const getMessageV2ReadReceiptQuery = gql`
  query messageV2ReadReceipt(
    $id: ID!
    $organizationId: ID!
    $readInput: ReadReceiptInput
    $unreadInput: ReadReceiptInput
  ) {
    node(id: $id, type: MESSAGEV2) {
      ... on MessageV2 {
        id
        label
        user_read: readReceipt(input: $readInput) {
          edges {
            node {
              ...userDetailItem
            }
          }
        }
        user_unread: readReceipt(input: $unreadInput) {
          edges {
            node {
              ...userDetailItem
            }
          }
        }
      }
    }
  }
  ${userFragment.userDetailItem}
`;

export const getMessageReadReceiptQuery = gql`
  query messageReadReceipt(
    $id: ID!
    $organizationId: ID!
    $readInput: ReadReceiptInput
    $unreadInput: ReadReceiptInput
  ) {
    node(id: $id, type: MESSAGE) {
      ... on Message {
        id
        label
        user_read: readReceipt(input: $readInput) {
          edges {
            node {
              ...userDetailItem
            }
          }
        }
        user_unread: readReceipt(input: $unreadInput) {
          edges {
            node {
              ...userDetailItem
            }
          }
        }
      }
    }
  }
  ${userFragment.userDetailItem}
`;
